import React, { Component } from 'react'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import moment from 'moment'

import InputStandard from 'components/input/standard'
import DateContainer from 'components/date-container/date-container'
import TimeInput from 'components/input/time'

import { 
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import {
    saveEvent
} from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'

import QuillWysiwyg from 'components/input/quill-wysiwyg'

class ModalEvent extends Component {
	state = {
        id: null,
		date: null,
		timeString: '12:00',
		timeUnit: 2,
		title: '',
		copy: '',
		wysiwygVisible: false
	}
	
	componentWillMount = _ => {
		if(this.props.data){
			const newState = {
				...this.props.data
			}

			if(this.props.data.time){
				const timeData = this.convertTimeFormats(false, this.props.data.time)

				newState.timeString = timeData.value
				newState.timeUnit = timeData.isPm ? 2 : 1
			}

            this.setState(newState)
		}
	}
	
	componentDidMount = _ => { 
		setTimeout(_ => {
			this.setState({
				wysiwygVisible: true
			}, _ => {
				if (this.announcementRef) {
					this.announcementRef.inputRef.focus()
				}else{
					setTimeout(_ => {
						if (this.copyBox) {
							this.copyBox.quillRef.focus()
						}
					},1)
				}
			})
		}, 1)
	}

	convertTimeFormats = (to24 = false, value, unit) => {
		let returnValue

		if(to24){
			returnValue = parseInt(value.replace(':','')) + (unit == 2 ? 1200 : 0)

			if(returnValue >= 2400){
				returnValue -= 1200
			}
		}else{
			let isPm = value > 1159

			returnValue = value

			if(value > 1259){
				returnValue -= 1200
			}

			returnValue = returnValue.toString()

			if(returnValue.length < 4){
				returnValue = '0'+returnValue
			}

			returnValue = returnValue.slice(0, 2) + ":" + returnValue.slice(2)

			return {
				value: returnValue,
				isPm
			}
		}

		if(returnValue){
			return returnValue
		}else{
			return ''
		}
	}

	handleSubmit = _ => {
		const {
			isLoading,
			setLoading,
			accountData,
            handleError,
            saveEvent
        } = this.props
        
		if(isLoading){
			return 
        }
        
        if(!this.state.date){
            return handleError(`You'll need to pick a date.`)
        }else if(!this.state.title){
			return handleError(`Your event's gonna need a title.`)
		}
		
		const timeIn24 = this.convertTimeFormats(true, this.state.timeString, this.state.timeUnit)
        
        saveEvent({
			...this.state,
			time: timeIn24
		}, accountData, this.handleCallback)

		setLoading(true)
	}

	handleCallback = _ => {
		const {
			setLoading,
			handleSuccess,
			closeCallback
        } = this.props
        
		setLoading(false)
		handleSuccess(this.state.id ? "Event updated successfully." : "Event added successfully.")

		setTimeout(_ => {
			closeCallback()
		}, 1000)
	}

	handleChange = (type, value) => {
		switch(type){
			case 'copy':
				this.setState({
					copy: value
				})
				break
			case 'title':
				this.setState({
					title: this.announcementRef.inputRef.value
				})
				break
		}
	}
	
	handleTimeChange = (type, value) => {
		switch(type){
			case 'text':
				this.setState({
					timeString: value
				})
				break
			case 'unit':
				this.setState({
					timeUnit: value
				})
				break
		}
	}
    
    toggleDatePicker = e => {
		const {
			modalState,
			openMenuCallback
		} = this.props

        e.stopPropagation()

        if(modalState.currentOpenMenu == 'start_date'){
			openMenuCallback(null)
		}else{
			openMenuCallback('start_date')
		}
    }

    handleDateChange = date => {
        this.setState({
            date: moment(date).format('Y-MM-DD')
        })

        this.props.openMenuCallback(null)
    }

    getInitialMonth = _ => {
        return new Date()
	}
	
	getDateTimeString = _ => {
		const {
			date,
			timeString,
			timeUnit
		} = this.state

		let returnValue = moment(date).format('MMMM Do')

		if(timeString && timeUnit){
			let tempTimeString = timeString

			if(tempTimeString.startsWith('0')){
				tempTimeString = tempTimeString.replace('0','')
			}

			returnValue += ', '+tempTimeString+(timeUnit == 1 ? 'am' : 'pm')
		}

		return returnValue
	}

	render() {		
		const {
			userData,
            closeCallback,
            handleDismiss,
			validateResponse,
            data,
            modalState,
            operation
        } = this.props
        
        const {
            title,
            copy,
			date,
			timeString,
			timeUnit,
			id,
			wysiwygVisible
        } = this.state

        let modalTitle = 'Create an event'

        let isEdit = true

        if(id){
            isEdit = operation == 'edit'

            if(isEdit){
                modalTitle = 'Edit event'
            }else{
                modalTitle = 'View event'
            }
        }

		return(
			<div>
				<h2>
					{ modalTitle }
				</h2>
				<div className={isEdit ? 'borders' : 'borders view-only'}>
					{ isEdit ?
						<div className="date-time-row">
							<DateContainer
								isEdit={isEdit}
								isOpen={modalState.currentOpenMenu}
								toggleCallback={this.toggleDatePicker}
								selectCallback={this.handleDateChange}
								initialMonth={this.getInitialMonth()}
								selectedDate={date}
							/>
							<TimeInput
								string={timeString}
								unit={timeUnit}
								handleChange={this.handleTimeChange}
								isEdit={isEdit}
							/>
						</div>
					:
						<div className="date-time-row">
							<div className="dates-container">
								{ this.getDateTimeString() }
							</div>
						</div>
					}
                    { isEdit ? 
                    <InputStandard
                        placeholder={`What's going on?`}
                        ref={ref => this.announcementRef = ref }
                        name="title"
                        onChange={_ => this.handleChange('title')}
                        value={title}
                    />
                    : 
                    <h3>
                        { title }
                    </h3>
                    }
                    { isEdit ?
					<QuillWysiwyg
						isVisible={wysiwygVisible}
						value={copy}
						onChange={value => {this.handleChange('copy', value)}}
						canCollaborate={false}
						objectId={-1}
						availableMentions={[]}
						canEdit={true}
						placeholder={"Any extra context?"}
						context="comment"
						ref={ref => this.copyBox = ref}
					/>
					:
                    <p dangerouslySetInnerHTML={{ __html: copy}} />
                    }
                    { isEdit ?
                    <ValidateResponse 
                        dismissCallback={handleDismiss} 
                        response={validateResponse} 
                    />
                    : null }
				</div>
                { isEdit ?
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.handleSubmit} 
					label={'Submit'} 
					icon={'check'}
				/>
                : null }
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={isEdit ? 'Cancel' : 'Close'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {  
  return {
    accountData: getCurrentAccount(state),
	userData: getCurrentUser(state),
  }
}

const ModalEventWithValidateResponse = withValidateResponse(ModalEvent)

export default connect(mapStateToProps, {
    saveEvent
})(ModalEventWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-event.jsx